import { Axios, baseUrl } from "./Axios";

export const fetchOrderDetails = async (orderId) => {
  return await Axios.get(`customer/laundry/order/details?order_id=${orderId}`);
};
export const fetchCoupon = async (payload) => {
  return await Axios.post("/customer/laundry/order/applycoupon", payload);
};
export const PayFastPayment = async (orderId) => {
  const token = localStorage.getItem("token");
  // return await fetch(`${baseUrl}/payfast-payment?group_id=${orderId}`, {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // });

  return await Axios.get(`/payfast-payment?group_id=${orderId}`, {
    baseURL: baseUrl,
  });
};
export const fetchOrders = async ({ limit, offset }) => {
  return Axios.get(
    `customer/laundry/order/running-orders?limit=${limit}&offset=${offset}`
  );
};
export const fetchOrdersHistory = async ({ limit, offset }) => {
  return Axios.get(
    `customer/laundry/order/list?limit=${limit}&offset=${offset}`
  );
};
export const changePayment = async (orderId) => {
  return Axios.post(
    "/customer/laundry/order/payment-method",
    {
      order_id: orderId,
    },
    {
      responseType: "json",
    }
  );
};
export const changePaymentMethod = async (orderId, status) => {
  return Axios.post(
    "/customer/laundry/order/savepayment_order",
    {
      order_id: orderId,
      order_status: status,
    },
    {
      responseType: "json",
    }
  );
};
export const trackOrder = async (orderId) => {
  return Axios.get(`/customer/laundry/order/track?order_id=${orderId}`, {
    responseType: "json",
  });
};
export const getFailedOrder = async () => {
  return Axios.get(`customer/laundry/order/getpayment_order`, {
    responseType: "json",
  });
};
export const cancelOrder = async (orderId) => {
  return Axios.put(
    "/customer/laundry/order/cancel",
    {
      order_id: orderId,
    },
    {
      responseType: "json",
    }
  );
};
export const fetchWeekDaysOff = async (id) => {
  return Axios.get(`/time-slots/WeekDaysOff/${id}`, { responseType: "json" });
};
export const customerPayingLaterOrders = async () => {
  return await Axios.get(
    `/v2/customer/laundry/order/customer-paying-later-orders?limit=1&offset=1`
  );
};
export const settleOutstanding = async (ids) => {
  return await Axios.post(
    `/v2/customer/laundry/order/settlements/outstanding`,
    { orders: ids },
    { responseType: "json" }
  );
};
export const fetchScheduledOrders = async (limit, offset) => {
  return await Axios.get("v2/customer/laundry/order/recurring", {
    responseType: "json",
    params: {
      limit,
      offset,
    },
  }).then((res) => res.data);
};
